import {useState} from "react";
import {createRoutine} from "../api";


export default function MakeRoutine ({token, setMakeRoutine}) {
    const [name, setName] = useState("");
    const [goal, setGoal] = useState("");


    const postRoutine = async () => {
        try {
            const result = await createRoutine(token, name, goal);
            console.log(result);
            return result;
        } catch (err) {
            console.log(err, "Unable to post routine.")
        }
    };
    
    return <form className="makeRoutine" onSubmit={event => {
        event.preventDefault();
        postRoutine();
        setName("");
        setGoal("");
        setMakeRoutine(false);
    }}>
        <h2>Create Routine</h2>
        <div className="form-element">
            <label htmlFor="create-title">Name</label>
            <input id="create-name" name="name" value={name} type="text" placeholder="What is the name of your routine?" required onChange={event => {setName(event.target.value)}}/>
        </div>
        <div className="form-element">
            <label htmlFor="create-goal">Goal</label>
            <textarea id="create-goal" name="create-goal" value={goal} required onChange={event => {setGoal(event.target.value)}}></textarea>
        </div>
        <div className="button-container">
            <button type="submit" className="form-button">Create</button>
            {/* <button id="activities" className="form-button">Activities</button>
            <button id="edit" className="form-button">Edit</button>
            <button id ="delete" className="form-button">Delete</button> */}
            <button type="button" className="form-button" onClick={((event) => {
                event.preventDefault();
                setMakeRoutine(false);
            })}> Cancel</button>
        </div>
    </form> 

}